const BLOCK_END = /<\/(?:p|div|li|h[1-6]|blockquote|pre|ul|ol)>|<br\s*\/?>/gi;
const KNOWN_TAG = /<\/?(?:p|br|strong|b|em|i|u|s|strike|h[1-6]|ul|ol|li|blockquote|pre|code|span|a)\b/i;

/**
 * Descriptions of tasks, notes and materials hold HTML written in the rich text editor, but the ones saved before
 * the editor existed are plain text.
 */
export function looksLikeHtml(value: string): boolean {
  return KNOWN_TAG.test(value);
}

function escapeHtml(text: string): string {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

/** HTML for the editor: plain text becomes paragraphs, HTML is kept as it is */
export function toEditorHtml(value: string | null | undefined): string {
  if (!value) return '';
  if (looksLikeHtml(value)) return value;
  return value.split(/\r?\n/).map(line => `<p>${escapeHtml(line)}</p>`).join('');
}

/** Text of a description without formatting, in the way the backend counts it: blocks are separated by one space */
export function richTextToPlainText(value: string | null | undefined): string {
  if (!value) return '';
  if (!looksLikeHtml(value)) return value.replace(/\s+/g, ' ').trim();

  const doc = new DOMParser().parseFromString(value.replace(BLOCK_END, match => `${match} `), 'text/html');
  return (doc.body.textContent ?? '').replace(/\s+/g, ' ').trim();
}

export function isRichTextEmpty(value: string | null | undefined): boolean {
  return richTextToPlainText(value) === '';
}
